import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Order} from '../models/order';

export const checkDispatchDateActionTypes = {
  GET: type('[Get Dispatch Date] Get'),
  GET_SUCCESS: type('[Get Dispatch Date] Get Success'),
  GET_FAIL: type('[Get Dispatch Date] Get Fail'),
};

export class CheckDispatchDateAddAction implements Action {
  readonly type = checkDispatchDateActionTypes.GET;
  constructor(public payload?: string) {
  }
}
export class CheckDispatchDateSuccessAction implements Action {
  readonly type = checkDispatchDateActionTypes.GET_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CheckDispatchDateFailAction implements Action {
  readonly type = checkDispatchDateActionTypes.GET_FAIL;
  constructor(public payload?: string) {}
}
